module.exports = " <p-select :model.sync=model @on-change=onChange :multiple=multiple :filterable=filterable :filter-method=filterMethod :placeholder=placeholder :disabled=disabled :size=size> <p-option-group :label=item.name v-for=\"(index,item) in content\"> <p-option v-for=\"(i,info) in item.shops\" :value=info.id>{{ info.name }}</p-option> </p-option-group> </p-select> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/xman/storeSearch/xstoresearch.vue
// module id = 313
// module chunks = 0